// plugins/remote-console.client.ts
const ADD_PREFIX = true;               // prefix istemezsen false yap
const PREFIX = "%c[server]";
const PREFIX_STYLE = "color:#6b7280";

// Prefix eklenmemesi gereken console metotları (etiket/ilk argüman hassas)
const NO_PREFIX_METHODS = new Set([
  "time",
  "timeEnd",
  "timeLog",
  "count",
  "countReset",
  "assert",
  // Olası profiler metodları (tarayıcı desteğine bağlı)
  "profile",
  "profileEnd"
]);

// Argümanları JSON string -> value çevir
function reviveArgs(jsonArgs: string[]): unknown[] {
  return jsonArgs.map(s => {
    try {
      const v = JSON.parse(s);
      if (v && typeof v === "object" && "__isError" in v) {
        const e = v as { name?: string; message?: string; stack?: string };
        const err = new Error(e.message ?? "");
        err.name = e.name ?? "Error";
        err.stack = e.stack;
        return err;
      }
      return v as unknown;
    } catch {
      return s; // bozuk JSON ise düz string bas
    }
  });
}

// Function.call için tip güvenli (unknown[]) çağrı köprüsü
function callFn(fn: unknown, thisArg: unknown, args: unknown[]) {
  return (fn as { apply(thisArg: unknown, args: unknown[]): unknown }).apply(thisArg, args);
}

let es: EventSource | null = null;

export default defineNuxtPlugin(() => {
  if (import.meta.server) return;

  if (!es) {
    es = new EventSource("/api/remote-console");

    es.addEventListener("log", (ev: MessageEvent) => {
      try {
        const { method, args } = JSON.parse(ev.data) as { method: string; args: string[] };
        const fn = (console as unknown as Record<string, unknown>)[method];

        const revived = reviveArgs(args);
        if (typeof fn === "function") {
          if (ADD_PREFIX && !NO_PREFIX_METHODS.has(method)) {
            callFn(fn, console, [PREFIX, PREFIX_STYLE, ...revived]);
          } else {
            callFn(fn, console, [...revived]);
          }
        } else {
          // Bilinmeyen console metodları için fallback
          callFn(console.log, console, [PREFIX, PREFIX_STYLE, `[${method}]`, ...revived]);
        }
      } catch {
        // sessiz kal
      }
    });

    if (import.meta.hot) {
      import.meta.hot.dispose(() => {
        es?.close();
        es = null;
      });
    }
  }
});